import { Directive, ElementRef, OnInit } from '@angular/core';
import { User } from 'app/models/User';

@Directive({
  selector: '[enAnonLock]'
})
export class AnonymousLockDirective implements OnInit {
  constructor(
    private element: ElementRef<HTMLElement>,
    private _userService: User
  ) {}

  ngOnInit(): void {
    if (this._userService.isAnonymous()) {
      const child = this.element.nativeElement;
      child.innerHTML = `<div class='freemium-lock mr-1'><i class='fa fa-lock'></i></div>`;
    }
  }
}
